import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  withIcon = false,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-[#E8845F] hover:bg-[#D67350] text-white shadow-lg shadow-orange-200 focus:ring-[#E8845F]',
    secondary: 'bg-[#4AAAA5] hover:bg-[#3B9691] text-white shadow-lg shadow-teal-200 focus:ring-[#4AAAA5]',
    outline: 'bg-transparent border-2 border-[#E8845F] text-[#E8845F] hover:bg-[#FFF5F0] focus:ring-[#E8845F]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank');
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-187">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-188" />}
    </button>;
}